import axios from 'axios'
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useToasts } from 'react-toast-notifications'
import { API } from "../../../helpers/constants";
import { changeDateFromSQL } from "../../../helpers/dates";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import useUserData from "../../../hooks/user/useUserData";
import { PROJECTS } from '../locales/namespaces'

const useProject = ({ projectId }) => {
	const LOCALE = window.BASE_LURL
	const { token } = useUserData()
	const { t } = useTranslation(PROJECTS)
	const [loading, setLoading] = useState(false)
	// const { addToast } = useToasts()
	const [project, setProject] = useState({})
	const [assignees,setAssignees] = useState([])
	const [projectWorks,setProjectWorks] = useState([])
	

	
	
	useEffect(() => {
		if (!projectId) {
			setLoading(true)
			axios({
				method: 'get',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/fts/project/create`
			}).then(res => {
				const data = res.data
				console.log(data.foremen)
				setAssignees({
					...data.foremen,

				})
				setLoading(false)
			}).catch(error => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
				setLoading(false)
			})
		}
		else{
			setLoading(true)
			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
				url: `${API}/en/fts/project/edit/`+ projectId
			}).then(res => {
				const data = res.data
				// console.log('edit',data)
				// debugger
				const project = data.project[0]
				setProject({
					// ...project,
					Description: project.Description ? project.Description : '',
					isActive: project.isActive === '1',
					EstimDt: project.EstimDt ? changeDateFromSQL(project.EstimDt) : '',
					StartDt: project.StartDt ? changeDateFromSQL(project.StartDt) : '',
					EndDt: project.EndDt ? changeDateFromSQL(project.EndDt) : '',
					AssigneeId: { id: project.AssigneeId, Description: project.AssigneeName },
					EstimCost: project.EstimCost ? project.EstimCost : ''
				
				})
				setAssignees({
					...data.foremen,

				})
				setProjectWorks({
					...data.projectWorks
				})
				// if (data && data.project.length > 0) {
				// 	setProject(...data.project);
				// }
				setLoading(false)
			}).catch(error => {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
				setLoading(false)
			})
		}
		
	}, [])
	
	return {
		loading,
		project,
		assignees,
		projectWorks
	}
}

export default useProject